import { _ } from "libs";

import React from "react";
import { NavLink } from "react-router-dom";

const Tabs = () => {
	return (
		<div className="subheader">
			<div className="wrap">
				<ul>
					<li>
						<NavLink to="/reservations/active">{_("reservations.nav.active")}</NavLink>
					</li>
					<li>
						<NavLink strict exact to="/reservations/past">
							{_("reservations.nav.past")}
						</NavLink>
					</li>
					<li>
						<NavLink to="/reservations/waiting-list">{_("reservations.nav.waiting_list")}</NavLink>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default Tabs;
